import React from 'react';

import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { StyledCarousel } from './styled';

export const CustomCarousel = (props) => {
  const arrowStyles = {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50% - 15px)',
    width: 30,
    height: 30,
    cursor: 'pointer'
  };

  return (
    <StyledCarousel
      infiniteLoop
      autoPlay
      showStatus={false}
      renderArrowPrev={(onClickHandler, hasPrev) =>
        hasPrev && (
          <IconButton
            onClick={onClickHandler}
            size="large"
            edge="start"
            color="inherit"
            style={{ ...arrowStyles, left: 30 }}>
            <ArrowBackIos />
          </IconButton>
        )
      }
      renderArrowNext={(onClickHandler, hasNext) =>
        hasNext && (
          <IconButton
            onClick={onClickHandler}
            size="large"
            edge="start"
            color="inherit"
            style={{ ...arrowStyles, right: 20 }}>
            <ArrowForwardIos />
          </IconButton>
        )
      }
      {...props}>
      {props.children}
    </StyledCarousel>
  );
};
